import { useEffect } from "react";

const FILLOUT_EMBED_ORIGIN = "https://forms.getanswersnow.com";

interface EventMessageProps {
  embedId: string;
  eventName: "form_init" | "form_submit" | "form_page_change";
  fn: (data: any) => void;
}

/**
 *
 * @description Use the hook to listen out for messages from the Fillout Embed iframe
 * and then call the function when an event is received.
 * @param {string} embedId - The ID of the embed iframe
 * @param {"form_init" | "form_submit" | "form_page_change"} eventName - The name of the event to listen for.
 * Check https://www.npmjs.com/package/@fillout/react#listening-for-form-events
 * @param {Function} fn - The function to call when the event is received
 * @returns {void} - The function to call when the event is received
 */
const useMessageListener = ({ embedId, eventName, fn }: EventMessageProps) => {
  useEffect(() => {
    if (embedId) {
      const debug = location.href.includes("FILLOUT_EMBED_DEBUG");

      const listener = (event: MessageEvent) => {
        try {
          if (
            event.origin === FILLOUT_EMBED_ORIGIN &&
            event.data.embedId === embedId &&
            event.data.type === eventName
          ) {
            if (debug) {
              console.log(["fillout embed MESSAGE", eventName, event.data]);
            }

            fn(event.data);
          }
        } catch (err) {
          console.error("Error in useMessageListener", err);
        }
      };

      if (debug) console.log(["fillout embed MOUNT", eventName]);

      window.addEventListener("message", listener);

      return () => {
        if (debug) console.log(["fillout embed UNMOUNT", eventName]);

        window.removeEventListener("message", listener);
      };
    }
  }, [embedId, eventName, fn]);
};

export default useMessageListener;
